import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationMessages,
  loadSimulationVehicleScreens,
  simulationCarEquityScreen,
} from '@/modules/simulation/route';
import { flowSearchSchema } from '@/shared/flow/define-flow';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Car Equity no caminho do legado (`router.tsx:1094-1107`, `vehicleProductCategory = 1`): o passo vai em `?passo=`.
// Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/contratar/veiculo/car-equity/')({
  validateSearch: flowSearchSchema(),
  staticData: { screen: simulationCarEquityScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationVehicleScreens, 'CarEquityRouteScreen'),
});
